"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    clear: 'איפוס',
    confirm: 'אישור',
    close: 'סגירה',
    showAdditionalOptions: 'הצג אפשרויות נוספות'
  },
  ar: {
    clear: 'ضبط',
    confirm: 'موافقة',
    close: 'إغلاق',
    showAdditionalOptions: 'إظهار الخيارات الإضافية'
  },
  en: {
    clear: 'Clear',
    confirm: 'OK',
    close: 'close',
    showAdditionalOptions: 'Show additional options'
  }
};